import * as React from 'react';
import { Header, Table } from '@amzn/awsui-components-react-v3';
import { EmptyState } from 'src/commons/EmptyState';
import { FGAPList } from 'aws-sdk/clients/awsdatalakegladstonelambda';
import { Link } from 'src/components/common/Link';
import { createFgaPolicyViewLink } from 'src/routes';

export interface FineGrainPoliciesTableProps {
  fgaPolicies: FGAPList;
}

export const FineGrainPoliciesTable = (props: FineGrainPoliciesTableProps) => {
  const columnDefinitions = [
    {
      id: 'fgapName',
      header: 'Policy name',
      cell: (item) => <Link href={createFgaPolicyViewLink(item?.id)}>{item?.tableData?.physicalName}</Link>,
      minWidth: 200,
    },
    {
      id: 'owner',
      header: 'Owner',
      cell: (item) => item?.ownerId,
      minWidth: 200,
    },
    {
      id: 'status',
      header: 'Status',
      cell: (item) => item?.status,
      minWidth: 200,
    },
    {
      id: 'statusReason',
      header: 'Status reason',
      cell: (item) => item?.statusReason,
      minWidth: 200,
    },
  ];

  return (
    <Table
      loadingText='Loading policies'
      columnDefinitions={columnDefinitions}
      items={props.fgaPolicies}
      resizableColumns
      header={<Header counter={`(${props.fgaPolicies.length})`}>Fine grain policies</Header>}
      empty={<EmptyState title='No policies' subtitle='No fine grain policies found for this dataset.' />}
    />
  );
};
